import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns Tailwind badge classes for a score value.
 * @param {number} score - Score value (0-10)
 * @returns {string} Badge class string
 */
export function scoreBadgeClass(score) {
  if (score >= 7) return 'bg-success/10 text-success';
  if (score >= 5) return 'bg-warning/10 text-warning';
  return 'bg-accent/10 text-accent';
}

/**
 * Returns a Tailwind background class for a progress bar based on score.
 * @param {number} score - Score value (0-10)
 * @returns {string} Background class string
 */
export function scoreBarClass(score) {
  if (score >= 7) return 'bg-success';
  if (score >= 5) return 'bg-warning';
  return 'bg-accent';
}
